var site;

site = site || {};

(function ($) {
  Drupal.behaviors.fragranceFinderQuestionFormatterV1 = {
    counter: 1,
    $parent: {},
    $resultsContainer: {},
    segmentAns: 0,
    isMobile: window.innerWidth < 1025,
    attach: function (context) {
      var self = this;
      var $modules = $('.js-fragrance-finder-question-formatter', context);

      $modules.each(function (index) {
        var $module = $(this);

        self.getDom($module);
        self.initSetup($module, $modules.length, index);
        self.setListeners($module, $modules);
      });
    },
    updateImages: function ($questionFormatter, background) {
      var self = this;
      var $container;

      if (
        $questionFormatter.hasClass(
          'js-fragrance-finder-question-formatter--last'
        ) &&
        self.isMobile
      ) {
        $container = $questionFormatter.find(
          '.js-fragrance-finder-question-formatter-container'
        );
        $container.css('background-image', 'url("' + background + '")');
      }
    },
    getDom: function ($module) {
      $module.nodes = {};
      $module.nodes.parent = $module.closest('.js-fragrance-finder-formatter');
      $module.nodes.resultFormatter = $module.nodes.parent.find('.js-fragrance-finder-result-formatter');
      $module.nodes.results = $module.nodes.parent.find('.js-fragrance-finder-result-panel');
      $module.nodes.contentHeader = $module.nodes.parent.find('.js-fragrance-finder-formatter-content');
      $module.nodes.options = $('.js-fragrance-finder-question-formatter-options', $module);
      $module.nodes.cta = $('.js-fragrance-finder-question-formatter-cta', $module);
      $module.nodes.questions = $module.nodes.options.children('.content-block-tout');
    },
    initSetup: function ($module, moduleCount, index) {
      var self = this;

      if (index > 0) {
        $module.addClass('fragrance-finder-question-formatter__options--hide');
      }
      if (index === moduleCount - 1) {
        $module.addClass('fragrance-finder-question-formatter--last js-fragrance-finder-question-formatter--last');
        $module.nodes.cta.removeClass('hidden');
      }
      self.isMobile
        ? $module.addClass('mobile')
        : $module.removeClass('mobile');
    },
    setListeners: function ($module, $modules) {
      var self = this;
      var segment;

      $module.nodes.questions.once().on('click', function () {
        var $question = $(this);
        var currentIndex = String($question.index());
        var answers = $module.nodes.parent.attr('data-answer');

        $module.nodes.parent.attr('data-answer', answers + currentIndex + ',');
        $module.addClass('fragrance-finder-question-formatter__options--hide');
        if (
          $question.closest('.js-fragrance-finder-question-formatter--last')
            .length === 0
        ) {
          $modules
            .eq(self.counter - 1)
            .addClass('fragrance-finder-question-formatter__options--hide');
          $modules
            .eq(self.counter)
            .removeClass('fragrance-finder-question-formatter__options--hide');
        } else if ($module.nodes.cta.length === 0) {
          self.lastQuestion($module);
        }
        self.counter++;
        self.fireAnalytic('Answer', currentIndex);
        self.questionChange($module);
      });

      if ($module.nodes.cta.length > 0) {
        $module.nodes.cta.once().on('click', function () {
          var $parent;
          var answers;

          $modules.addClass(
            'fragrance-finder-question-formatter__options--hide'
          );
          $parent = $module.closest('.js-fragrance-finder-formatter');
          if ($parent.length > 0) {
            answers = $parent.attr('data-answer');
            $parent.attr(
              'data-answer',
              answers + String(self.segmentAns) + ','
            );
          }

          self.counter++;
          self.fireAnalytic('Answer', segment);
          self.questionChange($module);
          self.lastQuestion($module);
        });
      }

      $(window).resize(
        _.debounce(function () {
          self.isMobile = window.innerWidth < 1025;
          $modules.each(function () {
            self.isMobile
              ? $(this).addClass('mobile')
              : $(this).removeClass('mobile');
          });
        }, 250)
      );
      $(document).on('segmented_drag_bar:update_image', function (e) {
        var $seg = e.payload['$el'];
        var background = e.payload['backgroundUrl'];
        var $questionFormatter = $seg.closest(
          '.js-fragrance-finder-question-formatter'
        );

        if ($questionFormatter.length > 0 && background) {
          self.updateImages($questionFormatter, background);
        }
      });
      $(document).on('segmented_drag_bar:segment_to_trigger', function (e) {
        var $seg = e.payload['$el'];
        var $questionFormatter = $seg.closest(
          '.js-fragrance-finder-question-formatter'
        );
        var $parent = $seg.closest('.js-fragrance-finder-question-formatter');
        var $questionModules = $parent.find(
          '.js-fragrance-finder-question-formatter'
        );

        if (
          !$questionFormatter.hasClass(
            'js-fragrance-finder-question-formatter--last'
          )
        ) {
          $questionModules
            .eq(self.counter - 1)
            .addClass('fragrance-finder-question-formatter__options--hide');
          $questionModules
            .eq(self.counter)
            .removeClass('fragrance-finder-question-formatter__options--hide');
        }

        self.segmentAns = e.payload['segment'];
      });
      $(document).on(
        'fragrance_finder_formatter:current_index_update',
        function (e) {
          self.counter = e.payload['currentIndex'];
        }
      );
    },
    questionChange: function ($module, selectedAnswer) {
      var self = this;
      var payload = {};

      payload['counter'] = self.counter;
      if (selectedAnswer) {
        payload['answer'] = selectedAnswer;
      }
      if ($module !== '') {
        payload['$parentEl'] = $module.nodes.parent;
      }

      $.event.trigger({
        type: 'fragrance_finder_question_formatter:question_change',
        payload: payload
      });
    },
    getClosestAnswer: function ($results, $parent, dataName) {
      var $result;
      var $closestAnswer = $($results[0]);
      var answerList = $parent.attr('data-answer').split(',');
      var scoreHighest = 0;
      var resultList;
      var score = 0;

      $results.each(function (parentIndex) {
        $result = $(this);
        if ($result.data(dataName)) {
          resultList = $result.data(dataName).split(',');
          $.each(resultList, function (resultIndex, resultValue) {
            if (resultValue === answerList[resultIndex]) {
              score++;
            }
          });

          if (score > scoreHighest) {
            $closestAnswer = $($results[parentIndex]);
            scoreHighest = score;
          }
          score = 0;
        }
      });

      return $closestAnswer;
    },
    lastQuestion: function ($module) {
      var self = this;
      var $closestAnswer;

      $closestAnswer = self.getClosestAnswer(
        $module.nodes.results,
        $module.nodes.parent,
        'result-indices'
      );
      $module.nodes.contentHeader.addClass('inactive');
      $module.nodes.resultFormatter.removeClass('hidden');
      $module.nodes.results.removeClass('fragrance-finder-result-panel--show');

      if ($closestAnswer && $closestAnswer.length > 0) {
        $closestAnswer.addClass('fragrance-finder-result-panel--show');
      }

      $.event.trigger({
        type: 'fragrance_finder_question_formatter:results_ready',
        payload: {
          $el: $closestAnswer
        }
      });
    },
    fireAnalytic: function (eventAction, eventLabel) {
      if (site && site.track) {
        site.track.evtLink({
          event_name: 'elFragranceFinder',
          event_category: 'Fragrance Finder',
          event_action: eventAction,
          event_label: String(eventLabel)
        });
      }
    }
  };
})(jQuery);
